import axios from 'axios';
import { COINCAP_API_ORIGIN, COINCAP_API_ORIGIN_KEY } from '@constants/environment';

const endpoints = {
  getRates: () =>
    axios.get(`${COINCAP_API_ORIGIN}/assets?ids=ethereum,polygon`, {
      headers: {
        Authorization: 'Bearer ' + COINCAP_API_ORIGIN_KEY,
      },
    }),
};

export default endpoints;
